import { AccountView } from './account-view.model';

export interface SellerAccountView extends AccountView {
  sellerId: number;
  companyStatus: CompanyStatus;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  companyEmail: string;
  companyPhone: string;
  companyFax: string;
  certifiedEmail: string;
  IBAN: string;
  sdiNumber: string;
  birthDate: Date;
  legalRepresentativeFirstName: string;
  legalRepresentativeLastName: string;
  legalRepresentativeEmail: string;
  legalRepresentativePhone: string;
  legalRepresentativeBirthCity: string;
  legalRepresentativeBirthState: string;
  legalRepresentativeBirthCountry: string;
  legalRepresentativeTaxCode: string;
  legalRepresentativeAddress: string;
  legalRepresentativeCity: string;
  legalRepresentativeZip: string;
  legalRepresentativeState: string;
  legalRepresentativeCountry: string;
  legalRepresentativeNationality: string;
  IDNumber: string;
  IDIssueDate: Date;
  IDIssuePlace: string;
  downPaymentPercentage: number;
  maxInterestRate: number;
  suggestedInterestRate: number;
  minInterestRate: number;
  today: Date;
  otherDocumentNotes?: string;
  onboardingAccountId?: string;
  canDoOnboarding?: boolean;
  checkProfileMsg?: string;
  showOnboardingButton?: number;
  onboardingId?: string;
}

export enum CompanyStatus {
  pendingValidation = 'PENDING_VALIDATION',
  rejected = 'REJECTED',
  target = 'TARGET',
  approved = 'APPROVED',
  notInterested = 'NOT_INTERESTED',
  pendingContract = 'PENDING_CONTRACT',
  activated = 'ACTIVATED',
  deactivated = 'DEACTIVATED',

  lead = 'LEAD',
  selling = 'SELLING',
  notSelling = 'NOT_SELLING',
  dangerous = 'DANGEROUS',
  toReview = 'TO_REVIEW',
  pendingActivation = 'PENDING_ACTIVATION',
}
